export default {
    422: 'Недопустимые значения для фильтра'
}
